import React, { useEffect } from 'react'
import '../../Css/Savani.css'
import img from '../../Image/about_img.png'
import Wave from 'react-wavify'
import Aos from 'aos'

const AboutSection = () => {

  useEffect(() => {
    Aos.init({
      duration: 1000,   
      once: true,       
    });
  }, []);

  return (
  <div className='relative overflow-hidden sm:top-[-50px] top-[-35px]'>
    <Wave fill='#fff' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5}} className='relative min-w-[1920px] h-[28px] '/>
    <div className='bg-white'>
      <div className='container'>
        <div className='flex items-center flex-wrap sm:pt-5'>
          <div className='lg:w-3/5 w-full lg:ps-3 lg:pe-10 mt-11'>
            <h4 className='sm:text-[24px] text-[18px] font-[700] text-txt_color'>About KALATHIYA</h4>
            <p className='sm:text-[16px] text-[14px] mb-5 mt-5 text-justify'> <span className='text-theme_dark font-[700]'>Kalathiya Infotech</span> is a amazing path of development and services company. With our comprehensive range of services, cutting-edge technologies, and a team of skilled experts, we empower our clients to achieve their goals and elevate their online presence.</p>
            <p className='sm:text-[16px] text-[14px]  text-justify'>Our diverse team of seasoned professionals brings together a wealth of experience and expertise across various domains, including software development, cybersecurity, cloud computing, and more. We pride ourselves on our ability to deliver scalable and sustainable solutions that drive tangible results for businesses of all sizes. At Kalathiya infotech we believe in harnessing the power of technology to empower our clients to thrive in an increasingly interconnected world. Discover the difference and embark on a journey towards digital transformation today.</p>
            <p className='sm:text-[16px] text-[14px] mb-5 text-justify'>Our team of skilled professionals brings together a wealth of experience and knowledge to deliver top-notch services in software development, cybersecurity, cloud computing, and beyond. At Kalathiya Infotech we strive for nothing less than perfection, working tirelessly to ensure our clients stay ahead in an ever-evolving digital landscape.</p>
          </div>
          <div className='lg:w-2/5 w-full ps-3 pe-3 mt-11' data-aos="fade-left">
            <div className='flex justify-center '>
              <img src={img} alt="" className='w-[470px] ' />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default AboutSection
